import { render, staticRenderFns } from "./UserTableItem.vue?vue&type=template&id=61d21445&scoped=true"
import script from "./UserTableItem.vue?vue&type=script&lang=js"
export * from "./UserTableItem.vue?vue&type=script&lang=js"
import style0 from "./UserTableItem.vue?vue&type=style&index=0&id=61d21445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d21445",
  null
  
)

export default component.exports